import Button from "components/buttons/Button"
import useTranslations from "hooks/useTranslations"
import cc from "classcat"

type ContactButtonProps = {
  bgStyle?:
    | "primary"
    | "light"
    | "dark"
    | "blue"
    | "yellow"
    | "cadetblue"
    | "black"
    | "green"
  left?: boolean
  oversized?: boolean
  label?: string
}

const ContactButton = ({
  bgStyle = "primary",
  left,
  oversized = false,
  label,
}: ContactButtonProps) => {
  const { schoolWebinarRequestLinkText } = useTranslations()
  return (
    <div
      className={cc([
        oversized ? "max-w-md" : "max-w-xs",
        left ? "" : "mx-auto",
      ])}
    >
      <Button
        bgStyle={bgStyle}
        label={label || schoolWebinarRequestLinkText}
        link="#contact"
        className={oversized ? "!py-10 text-lg" : ""}
      />
    </div>
  )
}

export default ContactButton
